import { apiClient } from "../../../lib/apiClient";
import type { ApiResponse } from "../../../types/apiResponse";
import type { ClientData } from "../types";

/** El backend responde 201 con { id } del cliente recién creado. */
export type CreateClientResponse = ApiResponse<{ id: number }>;

export const createClient = (payload: ClientData) => {
   return apiClient<CreateClientResponse>("/v1/client", {
      method: "POST",
      body: payload
   })
}
